import axios from 'axios';

export default class Form {
  constructor(id) {
    console.log("ID", id)
    this.id = id === null ? '0b828b82-3278-4c8a-a5f2-b1c74eb64238' : id;
    this.getUrl = `https://api.umbraco.io/forms/${this.id}/`;
    this.postUrl = `https://api.umbraco.io/forms/${this.id}/entries/`;
    this.config = {
      headers: {
        'Content-Type': 'application/json',
        'umb-project-alias': process.env.GATSBY_FORMS_UMBRACO_ENVIRONMENT,
        'Api-Key': process.env.GATSBY_UMBRACO_FORMS_API_KEY,
      },
    };
  }

  async get() {
    try {
      const res = await axios.get(this.getUrl, this.config);
      return res.data;
    } catch (err) {
      return console.log(err);
    }
  }
  async post(data) {
    try {
      const res = await axios.post(this.postUrl, JSON.stringify(data), this.config);
      return res;
    } catch (err) {
      return console.log(err);
    }
  }
}
